/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { utils, Contract, ContractFactory } from "ethers";
var _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "previousAdmin",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "newAdmin",
                type: "address",
            },
        ],
        name: "AdminChanged",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "beacon",
                type: "address",
            },
        ],
        name: "BeaconUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "oldContract",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newContract",
                type: "address",
            },
        ],
        name: "ContractUpgraded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "implementation",
                type: "address",
            },
        ],
        name: "Upgraded",
        type: "event",
    },
    {
        inputs: [],
        name: "chainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "hash",
                type: "bytes32",
            },
        ],
        name: "governanceActionIsConsumed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "governanceContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "impl",
                type: "address",
            },
        ],
        name: "isInitialized",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "product",
                type: "bytes32",
            },
            {
                internalType: "uint8",
                name: "priceType",
                type: "uint8",
            },
        ],
        name: "latestAttestation",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "magic",
                        type: "uint32",
                    },
                    {
                        internalType: "uint16",
                        name: "version",
                        type: "uint16",
                    },
                    {
                        internalType: "uint8",
                        name: "payloadId",
                        type: "uint8",
                    },
                    {
                        internalType: "bytes32",
                        name: "productId",
                        type: "bytes32",
                    },
                    {
                        internalType: "bytes32",
                        name: "priceId",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "priceType",
                        type: "uint8",
                    },
                    {
                        internalType: "int64",
                        name: "price",
                        type: "int64",
                    },
                    {
                        internalType: "int32",
                        name: "exponent",
                        type: "int32",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twap",
                        type: "tuple",
                    },
                    {
                        components: [
                            {
                                internalType: "int64",
                                name: "value",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "numerator",
                                type: "int64",
                            },
                            {
                                internalType: "int64",
                                name: "denominator",
                                type: "int64",
                            },
                        ],
                        internalType: "struct PythStructs.Ema",
                        name: "twac",
                        type: "tuple",
                    },
                    {
                        internalType: "uint64",
                        name: "confidenceInterval",
                        type: "uint64",
                    },
                    {
                        internalType: "uint8",
                        name: "status",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "corpAct",
                        type: "uint8",
                    },
                    {
                        internalType: "uint64",
                        name: "timestamp",
                        type: "uint64",
                    },
                ],
                internalType: "struct PythStructs.PriceAttestation",
                name: "attestation",
                type: "tuple",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeChainId",
        outputs: [
            {
                internalType: "uint16",
                name: "",
                type: "uint16",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "pyth2WormholeContract",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "wormhole",
        outputs: [
            {
                internalType: "contract IWormhole",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedVM",
                type: "bytes",
            },
        ],
        name: "upgrade",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "encodedUpgrade",
                type: "bytes",
            },
        ],
        name: "parseContractUpgrade",
        outputs: [
            {
                components: [
                    {
                        internalType: "bytes32",
                        name: "module",
                        type: "bytes32",
                    },
                    {
                        internalType: "uint8",
                        name: "action",
                        type: "uint8",
                    },
                    {
                        internalType: "uint16",
                        name: "chain",
                        type: "uint16",
                    },
                    {
                        internalType: "address",
                        name: "newContract",
                        type: "address",
                    },
                ],
                internalType: "struct PythStructs.UpgradeContract",
                name: "cu",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
var _bytecode = "0x608060405234801561001057600080fd5b50611291806100206000396000f3fe608060405234801561001057600080fd5b50600436106100a95760003560e01c806384acd1bb1161007157806384acd1bb1461017e578063970994ab146101995780639a8a0592146101b9578063b172b222146101c5578063d60b347f146101cd578063fbe3c2cd146101f957600080fd5b806325394645146100ae5780632c3c02a4146100c35780633cb0031e146100fb57806343aac090146101165780634fdc60fa14610128575b600080fd5b6100c16100bc366004610db9565b61020b565b005b6100e66100d1366004610d72565b60009081526005602052604090205460ff1690565b60405190151581526020015b60405180910390f35b60035461ffff165b60405161ffff90911681526020016100f2565b6004545b6040519081526020016100f2565b61013b610136366004610db9565b610328565b6040516100f291908151815260208083015160ff169082015260408083015161ffff16908201526060918201516001600160a01b03169181019190915260800190565b6000546040516001600160a01b0390911681526020016100f2565b6101ac6101a7366004610d8a565b610476565b6040516100f29190610fda565b60015461ffff16610103565b60025461011a565b6100e66101db366004610d44565b6001600160a01b031660009081526006602052604090205460ff1690565b60015462010000900461ffff16610103565b600080600061021984610681565b9250925092508181906102485760405162461bcd60e51b815260040161023f9190610fc7565b60405180910390fd5b5061026d8361014001516000908152600560205260409020805460ff19166001179055565b600061027c8460e00151610328565b80519091506350797468146102c25760405162461bcd60e51b815260206004820152600c60248201526b77726f6e67206d6f64756c6560a01b604482015260640161023f565b60015461ffff1661ffff16816040015161ffff16146103145760405162461bcd60e51b815260206004820152600e60248201526d1ddc9bdb99c818da185a5b881a5960921b604482015260640161023f565b61032181606001516108a0565b5050505050565b60408051608081018252600080825260208201819052918101829052606081018290529061035683826109cd565b82526103636020826111bd565b905061036f8382610a2b565b60ff1660208301526103826001826111bd565b9050816020015160ff166001146103db5760405162461bcd60e51b815260206004820152601960248201527f696e76616c696420436f6e747261637455706772616465203100000000000000604482015260640161023f565b6103e58382610a87565b61ffff1660408301526103f96002826111bd565b905061040583826109cd565b6001600160a01b0316606083015261041e6020826111bd565b9050808351146104705760405162461bcd60e51b815260206004820152601960248201527f696e76616c696420436f6e747261637455706772616465203200000000000000604482015260640161023f565b50919050565b610518604080516101c0810182526000808252602080830182905282840182905260608084018390526080840183905260a0840183905260c0840183905260e0840183905284519081018552828152908101829052928301529061010082019081526040805160608101825260008082526020828101829052928201529101908152600060208201819052604082018190526060820181905260809091015290565b50600091825260076020818152604080852060ff948516865282529384902084516101c081018652815463ffffffff81168252640100000000810461ffff16828501526601000000000000900485168187015260018201546060808301919091526002830154608083015260038084015480881660a0850152610100808204880b880b880b60c0860152690100000000000000000091829004830b830b90920b60e085015288518084018a52600486015480890b890b890b8252680100000000000000008082048a0b8a0b8a0b838a0152600160801b918290048a0b8a0b8a0b838d01529386019190915289519384018a52600586015480890b890b890b8552838104890b890b890b97850197909752909504860b860b90950b968101969096526101208101959095526006015467ffffffffffffffff8082166101408701529281048416610160860152908104909216610180840152600160501b909104166101a082015290565b604080516101608101825260008082526020820181905291810182905260608082018390526080820183905260a0820183905260c0820183905260e0820181905261010082018390526101208201526101408101919091526000606060008060006106f46000546001600160a01b031690565b6001600160a01b031663c0fd8bde886040518263ffffffff1660e01b815260040161071f9190610fc7565b60006040518083038186803b15801561073757600080fd5b505afa15801561074b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526107739190810190610e2d565b9250925092508161078a5791945092509050610899565b60015462010000900461ffff1661ffff16836060015161ffff16146107e65750506040805180820190915260168152753bb937b7339033b7bb32b93730b731b29031b430b4b760511b6020820152909350600092509050610899565b60025483608001511461083757505060408051808201909152601981527f77726f6e6720676f7665726e616e636520636f6e7472616374000000000000006020820152909350600092509050610899565b61014083015160009081526005602052604090205460ff161561087e5782600060405180606001604052806022815260200161123a60229139955095509550505050610899565b50506040805160208101909152600081529093506001925090505b9193909250565b60006108d37f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc546001600160a01b031690565b90506108de82610ae4565b60408051600481526024810182526020810180516001600160e01b031663204a7f0760e21b179052905160009182916001600160a01b0386169161092191610fab565b600060405180830381855af49150503d806000811461095c576040519150601f19603f3d011682016040523d82523d6000602084013e610961565b606091505b50915091508181906109865760405162461bcd60e51b815260040161023f9190610fc7565b50836001600160a01b0316836001600160a01b03167f2e4cc16c100f0b55e2df82ab0b1a7e294aa9cbd01b48fbaf622683fbc0507a4960405160405180910390a350505050565b60006109da8260206111bd565b83511015610a225760405162461bcd60e51b8152602060048201526015602482015274746f427974657333325f6f75744f66426f756e647360581b604482015260640161023f565b50016020015190565b6000610a388260016111bd565b83511015610a7e5760405162461bcd60e51b8152602060048201526013602482015272746f55696e74385f6f75744f66426f756e647360681b604482015260640161023f565b50016001015190565b6000610a948260026111bd565b83511015610adb5760405162461bcd60e51b8152602060048201526014602482015273746f55696e7431365f6f75744f66426f756e647360601b604482015260640161023f565b50016002015190565b610aed81610b24565b6040516001600160a01b038216907fbc7cd75a20ee27fd9adebab32041f755214dbc6bffa90cc0225b39da2e5c2d3b90600090a250565b803b610b885760405162461bcd60e51b815260206004820152602d60248201527f455243313936373a206e657720696d706c656d656e746174696f6e206973206e60448201526c1bdd08184818dbdb9d1c9858dd609a1b606482015260840161023f565b7f360894a13ba1a3210667c828492db98dca3e2076cc3735a920a3ca505d382bbc80546001600160a01b0319166001600160a01b0392909216919091179055565b600082601f830112610bd9578081fd5b8151602067ffffffffffffffff821115610bf557610bf5611211565b610c03818360051b01611164565b80838252828201915082860187848660071b8901011115610c22578586fd5b855b85811015610c8957608080838b031215610c3c578788fd5b610c44611117565b835181528684015187820152604080850151610c5f81611227565b90820152606084810151610c7281611227565b908201528552938501939190910190600101610c24565b5090979650505050505050565b80518015158114610ca657600080fd5b919050565b600082601f830112610cbb578081fd5b8151610cce610cc982611195565b611164565b818152846020838601011115610ce2578283fd5b610cf38260208301602087016111e1565b949350505050565b805161ffff81168114610ca657600080fd5b805163ffffffff81168114610ca657600080fd5b805167ffffffffffffffff81168114610ca657600080fd5b8051610ca681611227565b600060208284031215610d55578081fd5b81356001600160a01b0381168114610d6b578182fd5b9392505050565b600060208284031215610d83578081fd5b5035919050565b60008060408385031215610d9c578081fd5b823591506020830135610dae81611227565b809150509250929050565b600060208284031215610dca578081fd5b813567ffffffffffffffff811115610de0578182fd5b8201601f81018413610df0578182fd5b8035610dfe610cc982611195565b818152856020838501011115610e12578384fd5b81602084016020830137908101602001929092525092915050565b600080600060608486031215610e41578081fd5b835167ffffffffffffffff80821115610e58578283fd5b908501906101608288031215610e6c578283fd5b610e74611140565b610e7d83610d39565b8152610e8b60208401610d0d565b6020820152610e9c60408401610d0d565b6040820152610ead60608401610cfb565b606082015260808301516080820152610ec860a08401610d21565b60a0820152610ed960c08401610d39565b60c082015260e083015182811115610eef578485fd5b610efb89828601610cab565b60e083015250610100610f0f818501610d0d565b908201526101208381015183811115610f26578586fd5b610f328a828701610bc9565b918301919091525061014083810151908201529450610f5360208701610c96565b93506040860151915080821115610f68578283fd5b50610f7586828701610cab565b9150509250925092565b60008151808452610f978160208601602086016111e1565b601f01601f19169290920160200192915050565b60008251610fbd8184602087016111e1565b9190910192915050565b602081526000610d6b6020830184610f7f565b815163ffffffff16815261024081016020830151610ffe602084018261ffff169052565b506040830151611013604084018260ff169052565b50606083015160608301526080830151608083015260a083015161103c60a084018260ff169052565b5060c083015161105160c084018260070b9052565b5060e083015161106660e084018260030b9052565b50610100838101518051600790810b858401526020820151810b6101208601526040820151900b61014085015250506101208301516101606110ca81850183805160070b8252602081015160070b6020830152604081015160070b60408301525050565b61014085015167ffffffffffffffff9081166101c08601529085015160ff9081166101e0860152610180860151166102008501526101a09094015190931661022090920191909152919050565b6040516080810167ffffffffffffffff8111828210171561113a5761113a611211565b60405290565b604051610160810167ffffffffffffffff8111828210171561113a5761113a611211565b604051601f8201601f1916810167ffffffffffffffff8111828210171561118d5761118d611211565b604052919050565b600067ffffffffffffffff8211156111af576111af611211565b50601f01601f191660200190565b600082198211156111dc57634e487b7160e01b81526011600452602481fd5b500190565b60005b838110156111fc5781810151838201526020016111e4565b8381111561120b576000848401525b50505050565b634e487b7160e01b600052604160045260246000fd5b60ff8116811461123657600080fd5b5056fe676f7665726e616e636520616374696f6e20616c726561647920636f6e73756d6564a2646970667358221220bb0575acf38056d7082fb41ab539366739d9417dba9de59ea27d92ec274338fc64736f6c63430008040033";
var PythGovernance__factory = /** @class */ (function (_super) {
    __extends(PythGovernance__factory, _super);
    function PythGovernance__factory(signer) {
        return _super.call(this, _abi, _bytecode, signer) || this;
    }
    PythGovernance__factory.prototype.deploy = function (overrides) {
        return _super.prototype.deploy.call(this, overrides || {});
    };
    PythGovernance__factory.prototype.getDeployTransaction = function (overrides) {
        return _super.prototype.getDeployTransaction.call(this, overrides || {});
    };
    PythGovernance__factory.prototype.attach = function (address) {
        return _super.prototype.attach.call(this, address);
    };
    PythGovernance__factory.prototype.connect = function (signer) {
        return _super.prototype.connect.call(this, signer);
    };
    PythGovernance__factory.createInterface = function () {
        return new utils.Interface(_abi);
    };
    PythGovernance__factory.connect = function (address, signerOrProvider) {
        return new Contract(address, _abi, signerOrProvider);
    };
    PythGovernance__factory.bytecode = _bytecode;
    PythGovernance__factory.abi = _abi;
    return PythGovernance__factory;
}(ContractFactory));
export { PythGovernance__factory };
